module.exports = {"title":"Delete event","description":"Are you sure you want to delete that event?","delete":"Delete","cancel":"Cancel"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/ConfirmDeleteEventModal/locales/en.json
// module id = 1673
// module chunks = 0